import { createEntityAdapter } from '@reduxjs/toolkit';
import { parseISO, compareDesc } from 'date-fns';

const adapter = createEntityAdapter({
  selectId: (product) => product.id,
  sortComparer: (a, b) => compareDesc(parseISO(a.created_at), parseISO(b.created_at)),
});

export default adapter;
